import React from 'react';
import { Flex, Typography } from '@banhala/ui-kit';

type DoublePointChipProps = {
  visible: boolean;
};

export const DoublePointChip: React.FC<DoublePointChipProps> = ({
  visible,
}) => {
  if (!visible) return null;

  return (
    <Flex
      padding={{ horizontal: 6, vertical: 2 }}
      backgroundColor={'bg_secondary'}
      borderRadius={'small'}
    >
      <Typography type={'body5'} color={'content_secondary'}>
        2배 적립
      </Typography>
    </Flex>
  );
};